export const colors = {
    name: 'Colors',
    position: 1,
    fields: []
};
